// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

import 'owl.carousel2/dist/owl.carousel';
import './util/customSelect';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateFlexibleDefault from './routes/template-flexible-default';
import templateNewsListing from './routes/template-news-listing';
import templateEventListing from './routes/template-event-listing';
import templateContact from './routes/template-contact';
import singlePost from './routes/single-post';
import singleEvent from './routes/single-event';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Flexi default
  templateFlexibleDefault,
  // News listing
  templateNewsListing,
  // Event listing
  templateEventListing,
  // Contact
  templateContact,
  // News post
  singlePost,
  // Event detail
  singleEvent,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js